<template>
	<div class="formulate-tree-select">
		<Treeselect
			:class="{'showPlaceholder': !hideTreeSelectPlaceholderOnSearch }"
			:options="context.options"
			:value-consists-of="'LEAF_PRIORITY'"
			v-bind="context.attrs"
			:modelValue="context.value"
			@update:modelValue="context.node.input"
			ref="select"
		>
			<template #value-label />
		</Treeselect>
		<div class="formulate-tree-select__options">
			<div @click="onOptionClick(option)" v-for="option in selectedOptions" :key="option.id" class="button--option button">
				<span class="icon icon--cross icon--dark">remove</span>
				{{ option.label }}
			</div>
		</div>
	</div>
</template>


<script src="./FormulateTreeSelect.js"></script>
